import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Typography
} from '@material-ui/core'
import Rating from '@material-ui/lab/Rating'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import { getGrade, dateFormat, numberFormat } from 'helpers'
import { ExModalHide } from '../ExModal'

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  actions: {
    justifyContent: 'flex-end'
  },
  hideButton: {
    marginRight: theme.spacing(1),
    minWidth: 135,
    backgroundColor: '#fa591d',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#e04d18'
    }
  },
  showButton: {
    marginRight: theme.spacing(1),
    minWidth: 135,
    backgroundColor: '#00a651',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#008c44'
    }
  },
  productCell: {
    display: 'flex',
    alignItems: 'center'
  },
  imageContainer: {
    height: 50,
    width: 50,
    minWidth: 50,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5)
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
}))

const ExTable = props => {
  const { 
    className, 
    reviews, 
    page, 
    pages, 
    limit, 
    onChangePage, 
    onChangeRowsPerPage,
    onHideData,
    ...rest 
  } = props
  const classes = useStyles()

  const [selectedId, setSelectedId] = useState(0)
  const [selectedIsShow, setSelectedIsShow] = useState(true)
  const [modalHide, setModalHide] = useState(false)

  const handleShowModalHide = (reviewId, isShow) => {
    setSelectedId(reviewId)
    setSelectedIsShow(isShow !== undefined ? isShow : true)
    setModalHide(true)
  }

  const handleCloseModalHide = () => {
    setModalHide(false)
  }

  const handleConfirmHide = () => {
    onHideData(selectedId)
    setModalHide(false)
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No</TableCell>
                  <TableCell>Produk</TableCell>
                  <TableCell>Agen</TableCell>
                  <TableCell>Website</TableCell>
                  <TableCell>Bintang</TableCell>
                  <TableCell>Review</TableCell>
                  <TableCell>Tanggal</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(reviews || []).map((item, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={item.id}
                  >

                    <TableCell>{((page * limit) - limit) + (index + 1)}</TableCell>
                    <TableCell>
                      <div className={classes.productCell}>
                        {item.product && item.product.image ? (
                          <div className={classes.imageContainer}>
                            <img
                              alt={item.product.name}
                              className={classes.image}
                              src={process.env.REACT_APP_IMAGE_URL + item.product.image}
                            />
                          </div>
                        ) : null}
                        <div>
                          <Typography variant="body1" style={{ fontWeight: 500 }}>
                            {item.product ? item.product.name : '-'}
                          </Typography>
                          {item.orders ? (
                            <Typography variant="body2" color="textSecondary">
                              {item.orders.quantity || 0} x {numberFormat(String(item.orders.price || 0), 'Rp. ')} = {numberFormat(String((item.orders.quantity || 0) * (item.orders.price || 0)), 'Rp. ')}
                            </Typography>
                          ) : null}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      {
                        item.user
                          ? `${item.user.name || '-'} ${item.user.phone ? `(${item.user.phone})` : ''}`
                          : '-'
                      }
                    </TableCell>
                    <TableCell>
                      {
                        item.user && item.user.group === 'herbalkatalog'
                          ? 'Herbal Katalog'
                          : item.user && item.user.group === 'supergrosir'
                            ? 'Super Grosir Herbal'
                            : item.user && item.user.group === 'dropshipping'
                              ? 'Dropshipping Herbal'
                              : (item.user && item.user.group) ? item.user.group : '-'
                      }
                    </TableCell>

                    <TableCell>
                      <Rating value={Number(item.star) || 0} readOnly precision={0.5} size="small" />
                    </TableCell>
                    <TableCell>{item.review}</TableCell>
                    <TableCell>{dateFormat(item.created_at || item.updated_at)}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={item.isShow ? <VisibilityOff /> : <Visibility />}
                        className={item.isShow ? classes.hideButton : classes.showButton}
                        onClick={() => handleShowModalHide(item.id, item.isShow)}
                      >
                        {item.isShow ? 'Sembunyikan' : 'Tampilkan'}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={pages * limit}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>

      <ExModalHide 
        open={modalHide} 
        onClose={handleCloseModalHide} 
        onHide={handleConfirmHide}
        isShow={selectedIsShow}
      />
    </Card>
  )
}

ExTable.propTypes = {
  className: PropTypes.string,
  reviews: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onHideData: PropTypes.func.isRequired
}

export default ExTable
